/**
 * 테넌트 정보 카드
 */

import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { UserProfile } from "app/types/UserProfile"

interface TenantInfoCardProps {
    userProfile: UserProfile | null
}

function TenantInfoCard({ userProfile }: TenantInfoCardProps): JSX.Element {
    if (!userProfile) {
        return (
            <Card sx={{ height: "100%", boxShadow: "none" }}>
                <MDBox p={2}>
                    <MDTypography variant="body2" color="text">
                        정보 없음
                    </MDTypography>
                </MDBox>
            </Card>
        )
    }

    return (
        <Card sx={{ height: "100%", boxShadow: "none" }}>
            <MDBox p={2}>
                <MDBox mb={2} display="flex" alignItems="center">
                    <Icon fontSize="medium" color="info">domain</Icon>
                    <MDTypography variant="h6" fontWeight="medium" ml={1}>
                        소속 조직
                    </MDTypography>
                </MDBox>

                <Grid container spacing={2}>
                    {/* 조직명 */}
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDBox display="flex" alignItems="center">
                                <Icon fontSize="small" sx={{ mr: 1 }}>business</Icon>
                                <MDTypography variant="button" fontWeight="regular" color="text">
                                    조직명
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="button" fontWeight="bold" color="text">
                                {userProfile.tenantName || "-"}
                            </MDTypography>
                        </MDBox>
                    </Grid>

                    {/* 조직 ID */}
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDBox display="flex" alignItems="center">
                                <Icon fontSize="small" sx={{ mr: 1 }}>tag</Icon>
                                <MDTypography variant="button" fontWeight="regular" color="text">
                                    조직 ID
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="button" fontWeight="bold" color="text">
                                {userProfile.tenantId || "-"}
                            </MDTypography>
                        </MDBox>
                    </Grid>

                    {/* 역할 */}
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDBox display="flex" alignItems="center">
                                <Icon fontSize="small" sx={{ mr: 1 }}>badge</Icon>
                                <MDTypography variant="button" fontWeight="regular" color="text">
                                    역할
                                </MDTypography>
                            </MDBox>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                color={
                                    userProfile.tenantRole === "ADMIN" ||
                                        userProfile.tenantRole === "ADM" ||
                                        userProfile.tenantRole === "OWNER"
                                        ? "info"
                                        : "text"
                                }
                            >
                                {userProfile.tenantRole || "USER"}
                            </MDTypography>
                        </MDBox>
                    </Grid>

                    {/* 가입일 */}
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDBox display="flex" alignItems="center">
                                <Icon fontSize="small" sx={{ mr: 1 }}>event</Icon>
                                <MDTypography variant="button" fontWeight="regular" color="text">
                                    가입일
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="button" fontWeight="bold" color="text">
                                {userProfile.crtDt
                                    ? new Date(userProfile.crtDt).toLocaleDateString("ko-KR")
                                    : "-"}
                            </MDTypography>
                        </MDBox>
                    </Grid>

                    {/* 계정 상태 */}
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDBox display="flex" alignItems="center">
                                <Icon fontSize="small" sx={{ mr: 1 }}>
                                    {userProfile.isActive ? "check_circle" : "cancel"}
                                </Icon>
                                <MDTypography variant="button" fontWeight="regular" color="text">
                                    계정 상태
                                </MDTypography>
                            </MDBox>
                            <MDTypography
                                variant="button"
                                fontWeight="bold"
                                color={userProfile.isActive ? "success" : "error"}
                            >
                                {userProfile.isActive ? "활성" : "비활성"}
                            </MDTypography>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </Card>
    )
}

export default TenantInfoCard
